module.exports = __webpack_public_path__ + "static/img/0.9a1a3a5d.png";